import { SingleSelectionGroup } from '@paypalcorp/pp-react'
import React, { ChangeEvent, useContext, useEffect } from 'react'
import './code-selector.css'
import { CheckoutSimulatorContext } from '../context/CheckoutSimulatorContext'
import withAnalytics from '../../../utils/withAnalytics'

const CodeSelectorButtons: React.FC = () => {
  const fptiData = typeof window !== `undefined` && window.fpti
  const { options, setOptionValue, setIntegrationType, updateSnippets } =
    useContext(CheckoutSimulatorContext)

  const recordAnalytics = (buttonSelected: string) => {
    if (fptiData && window.PAYPAL?.analytics?.instance) {
      const event = `button_${buttonSelected}`
      window.PAYPAL.analytics.instance.record({
        data: {
          page: 'main:developer:integration-builder',
          pgrp: 'main:developer:integration-builder',
          e: 'cl',
          link: event,
          event_action: event,
          ...fptiData,
        },
      })
    }
  }

  useEffect(() => {
    updateSnippets()
  }, [options])

  return (
    <>
      {options.map((option) => {
        return (
          <SingleSelectionGroup
            key={option.name}
            name={option.name}
            label={option.label}
            responsive="md"
            options={option.buttons.filter(
              (button) =>
                !button.conditions ||
                button.conditions.filter((condition) => {
                  let conditionOption = options.find(
                    (conditionOption) =>
                      conditionOption.name === condition.option,
                  )
                  return conditionOption?.value === condition.value
                }).length === button.conditions.length,
            )}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              recordAnalytics(event.target.value)
              setOptionValue(option.name, event.target.value)
              if (option.name === 'integration') {
                setIntegrationType(event.target.value)
                if (
                  event.target.value === 'standard' &&
                  options.find((option) => option.name === 'backend')?.value ===
                    'java'
                )
                  setOptionValue('backend', 'nodejs')
              }
            }}
            value={
              typeof option.value === 'function' ? option.value() : option.value
            }
          />
        )
      })}
    </>
  )
}

export default withAnalytics(CodeSelectorButtons)
